module.exports = __webpack_public_path__ + "img/strand en vliegers.fc4e0efb.jpg";